import { selectXsrfToken } from 'modules/auth/selectors';
import type { Dispatch, GetState } from 'model/State';
import watchProgress from 'model/watchProgress';
import * as auth from 'modules/auth';
import { fetchSingleOrder } from '../orders';

export default async (dispatch: Dispatch, getState: GetState) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  if (!xsrfToken) {
    auth.actions.goToLogin();
    return;
  }

  const { orderId } = getState().location.payload;
  const verificationHash = getState().location.query?.hash;

  dispatch(fetchSingleOrder(orderId, verificationHash));
};
